import { useMemo } from 'react';

import { ValidationItems } from '@kanda-libs/ks-component-ts';

import { EmploymentClassType } from 'pages/Apply/YourInfo/EmploymentInformationFields/PrimaryEmployment/types';

import {
  AddressManualWidgets,
  PRIMARY_EMPLOYED_WIDGETS,
  SECONDARY_EMPLOYED_WIDGETS,
} from './constants';

import {
  AddressFieldBaseNames,
  useEmploymentAddressFieldsContext,
} from '../../context';

export interface AddressManualHook {
  show: boolean;
  widgets: AddressManualWidgets;
  buildingValidation: ValidationItems;
  postcodeValidation: ValidationItems;
  title: string;
  postcodeName: string;
  onPostcodeBlur: () => void;
  fieldNames: AddressFieldBaseNames;
  employmentClass: EmploymentClassType;
}

export default function useAddressManual(): AddressManualHook {
  const {
    manual,
    employmentClass,
    employmentStatus,
    buildingValidation,
    postcodeValidation,
    title,
    postcodeName,
    onPostcodeBlur,
    fieldNames,
  } = useEmploymentAddressFieldsContext();

  const widgets = useMemo(() => {
    if (employmentClass === 'primary')
      return PRIMARY_EMPLOYED_WIDGETS[employmentStatus];
    return SECONDARY_EMPLOYED_WIDGETS[employmentStatus];
  }, [employmentClass, employmentStatus]);

  return {
    show: manual,
    widgets,
    buildingValidation,
    postcodeValidation,
    title,
    postcodeName,
    onPostcodeBlur,
    fieldNames,
    employmentClass,
  };
}
